<ng-container [formGroup]="formGroup.control">
  <div class="op-form--section-header">
    <h3 [textContent]="text.title" class="op-form--section-header-title"></h3>
  </div>

  @for (workday of localeWorkdays; track workday; let i = $index) {
    <spot-selector-field
      formArrayName="workdays"
      [label]="workday"
      [control]="controlForLocalWorkday(workday)"
      >
      <input
        slot="input"
        type="checkbox"
        [formControlName]="indexOfLocalWorkday(workday)"
        />
    </spot-selector-field>
  }

  <op-pause-reminders />
</ng-container>
